<template>
  <div v-if="'vertical' === layoutMode">
    <!--左右布局-->
    <div :class="classObj" class="app-wrapper">
      <div
              v-if="device === 'mobile' && sidebar.opened"
              class="drawer-bg"
              @click="handleClickOutside"
      />
      <Sidebar class="sidebar-container" />
      <div class="main-container">
        <div>
          <NavBar />
        </div>
        <AppMain />
      </div>
    </div>
  </div>
  <div v-else>
    <AppMain />
  </div>

</template>

<script setup>
import { NavBar, AppMain, Sidebar } from "./Components";
import { onMounted, computed, getCurrentInstance, watch,ref } from "vue";
import { storeToRefs } from "pinia";
import { apiGetProjects } from "@/Api/AppApi";
import { useAppStore } from "@/Store/AppStore";
import { useProjectStore } from "@/Store/ProjectStore";
import { useRoute, useRouter } from "vue-router";
import * as Settings from "./../settings";
const { appContext } = getCurrentInstance();
const $message = appContext.config.globalProperties.$message;

const appStore = useAppStore();
const projectStore = useProjectStore();
const route = useRoute();
const router = useRouter();
const layoutMode = ref("");
if (!window.__POWERED_BY_QIANKUN__) {
  layoutMode.value = Settings.layoutMode;
  onMounted(async () => {
    const projectList = projectStore.projectList;
    if (projectList.length === 0) {
      const res = await apiGetProjects();
      if (res.code === 0) {
        const data = res.data;
        if (data.length === 0) {
          $message.error("你似乎没有权限哦~");
        } else {
          // 上次访问的id
          const id =
                  route.query.project || appStore.pageState.selectproject || data[0].id;
          projectStore.updateProjectList(data);
          projectStore.changeCurrentProject(id);
        }
      } else {
        $message.error(res.message);
      }
    } else {
      const currentProjectId = projectStore.currentProjectId;
      if (currentProjectId === "") {
        const id =
                route.query.project || // 路由导航的id
                appStore.pageState.selectproject || // 上次访问的id
                projectList[0].id;
        projectStore.changeCurrentProject(id);
      } else {
        if (
                !projectStore.isTester &&
                !projectStore.isAdmin &&
                !projectStore.isSuperAdmin
        ) {
          $message.error("你似乎没有权限哦~");
          // router.push("/home");
        } else {
          projectStore.checkRoute();
        }
      }
    }
  });
} else {
  layoutMode.value = "";
}

watch(
  () => route.query?.project,
  (val) => {
    // 监听浏览器前进后退，无参数和退出页面时不处理
    if (val && route.path.startsWith("/console")) {
      projectStore.changeCurrentProject(val);
    }
  }
);

const { sidebar, device } = storeToRefs(appStore);
const classObj = computed(() => {
  return {
    hideSidebar: !sidebar.value.opened,
    openSidebar: sidebar.value.opened,
    withoutAnimation: sidebar.value.withoutAnimation,
    mobile: device.value === "mobile",
  };
});

function handleClickOutside() {
  appStore.closeSideBar({ withoutAnimation: false });
}
</script>

<style lang="scss" scoped>
@import "../Styles/Mixin.scss";
@import "../Styles/Variables.scss";

.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;

  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}

.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}

.fixed-header {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9;
  width: calc(100% - #{$sideBarWidth});
  transition: width 0.28s;
}

.hideSidebar .fixed-header {
  width: calc(100% - 54px);
}

.mobile .fixed-header {
  width: 100%;
}
</style>
